var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CurriculumInterfaceDomainListCard',{ref:"domainListCard",attrs:{"domain-id":_vm.domainId,"text-id":_vm.textId,"text-name":_vm.textName,"details":_vm.details}})
}
var staticRenderFns = []

export { render, staticRenderFns }